import React from 'react'

import { ENTRIES } from '@/constants/content-stack'
import { Container } from '@/pages/UnrecoverableError/components/InstructionsList.styled'
import { UnrecoverableErrorEntry } from '@/pages/UnrecoverableError/types'
import { useContentStack } from '@/services/content-stack'

export function InstructionsList() {
  const { entry } = useContentStack<UnrecoverableErrorEntry>({
    entryParams: ENTRIES.UNRECOVERABLE_ERROR,
    ensuresEntryFulfilled: true,
  })

  return (
    <Container>
      {entry.instructions.map((__html) => (
        <div
          key={__html}
          dangerouslySetInnerHTML={{
            __html,
          }}
        ></div>
      ))}
    </Container>
  )
}
